import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"
import VideoPlayerBack from "components/VideoPlayBack"
import ImagesRow from "components/Cards/ImageGallery/ImagesRow"
import { useState } from "react"

const mediaTypes = {
  new: {
    media: "media",
    video: "video",
  },
  old: {
    media: "oldMedia",
    video: "oldVideo",
  },
}

const indexHandler = (data, array) => {
  let index = 0
  array.forEach((item, idx) => {
    if (item._id == data._id) {
      index = idx
    }
  })
  return index
}

const Card = ({
  data,
  previewHandler,
  mediaType,
  title,
  videoPlayerHandler,
}) => {
  const { t } = useTranslation()
  const [mainImage, setMainImage] = useState({})
  const [mainType, setMainType] = useState("image")

  useEffect(() => {
    if (Object.keys(mainImage).length <= 0) {
      setMainImage(() => data[mediaTypes[mediaType]?.media][0])
    }
  }, [])
  const mainImageHandler = (item, srcType) => {
    if (srcType === "image") {
      setMainType(() => "image")
      setMainImage(() => item)
    }
    if (srcType === "video") {
      setMainType(() => "video")
    }
  }
  return (
    <div className="flex flex-col items-center justify-center w-full px-0 py-6 transition-all duration-200 rounded-md xl:px-6 xl:pl-0 ">
      <div className="flex items-center justify-between w-full px-8">
        <h2>{title}</h2>
        <p className="hidden py-3 lg:block">{t("photo-galary")}</p>
      </div>
      <div className="flex flex-col items-start justify-between w-full h-full gap-3 md:flex-row">
        <div className="relative w-full lg:max-w-[70%] h-full lg::max-h-64 lg:max-h-[400px] flex lg:justify-start justify-center items-center">
          {mainType === "image" ? (
            <button
              className="shadow-inner group"
              onClick={() =>
                previewHandler(
                  indexHandler(mainImage, data[mediaTypes[mediaType]?.media]),
                  data[mediaTypes[mediaType]?.media]
                )
              }
            >
              <img
                src={mainImage?.image}
                alt={mainImage?.thumb}
                loading="lazy"
                className="w-full object-cover bg-contain h-full cursor-pointer max-h-64 lg:min-h-[370px] lg:max-h-[370px]"
              />
            </button>
          ) : (
            <div className="w-full h-full object-contain bg-cover max-h-64 lg:min-h-[370px] lg:max-h-[370px]">
              <VideoPlayerBack url={data[mediaTypes[mediaType]?.video][0]} />
            </div>
          )}
        </div>
        <div className="flex flex-col items-center justify-start w-full md:max-w-[130px]">
          <p className="block py-3 lg:hidden">{t("photo-galary")}</p>
          <ImagesRow
            data={data[mediaTypes[mediaType]?.media]}
            handleImage={mainImageHandler}
            video={data[mediaTypes[mediaType]?.video]}
            videoPlayerHandler={videoPlayerHandler}
          />
        </div>
      </div>
    </div>
  )
}

export default Card
